const getters = {
  audioUrl: state => state.common.audioUrl,
  playAudioFlag: state => state.common.playAudioFlag,
  socketAlarmData: state => state.common.socketAlarmData
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js